import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Label as LabelForm, Field, Input } from "@zendeskgarden/react-forms";
import  { t } from "../../../../../translations/translation.service";

class LinkedInModal extends React.Component <{
  showlinkedin: boolean,
  handleUpdateLinkedIn: any,
  updateLinkedInUrl: any,
  user: any,
  setUser: any
}> {

  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

 state = {
  urlLinkedIn: this.props.user.linkedinUrl
}

  handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { target } = event;
    this.setState({ urlLinkedIn: target.value }, () => {
      const userAtualizado = { ...this.props.user, linkedinUrl: target.value };
      this.props.setUser(userAtualizado);
    });
  }

  handleSave = () => {
    const userAtualizado = {
      ...this.props.user,
      linkedinUrl: this.state.urlLinkedIn
    };
    this.props.setUser(userAtualizado);
    this.props.updateLinkedInUrl(userAtualizado);
    this.props.handleUpdateLinkedIn();
  };

  componentDidUpdate(prevProps: any) {
    if (prevProps.user.linkedinUrl !== this.props.user.linkedinUrl) {
      this.setState({ urlLinkedIn: this.props.user.linkedinUrl || "" });
    }
  }

  render() {
    return (
      <Modal
        show={this.props.showlinkedin}
        onHide={() => this.props.handleUpdateLinkedIn()}
        backdrop={true}
        keyboard={true}
      >
        <Modal.Header className="d-flex justify-content-center">
            <LabelForm className="linkedin"
          >
            {t("Editar URL Linkedin")}
          </LabelForm>
          <button
            onClick={() => this.props.handleUpdateLinkedIn()}
            className='linkedin-close-modal'
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
        <Field>
          <LabelForm style={{ width: "100%" }} className="text-label">
            <span className="text-label">{t("URL Linkedin")}</span>
            <Input
              value={this.state.urlLinkedIn}
              name="linkedinUrl"
              className="mt-2"
              onChange={this.handleChange}
            />
            </LabelForm>
        </Field>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around">
          <div className="w-100 d-flex justify-content-center">
            <Button
              className="view-button-save-expectation"
              onClick={this.handleSave}
            >
              {t("Salvar")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default LinkedInModal;